export default "__VITE_ASSET__Q6aoQXqo__"